import { render, staticRenderFns } from "./PessoaHipertensao.vue?vue&type=template&id=4881071e"
import script from "./PessoaHipertensao.vue?vue&type=script&lang=js"
export * from "./PessoaHipertensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports